module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['col-4', _vm.tableClass]
  }, [_c('div', {
    class: ['corner-rl', 'd-flex', 'justify-content-start', 'align-items-center', _vm.name + '-icon']
  }, [_c('div', {
    staticClass: "icon",
    staticStyle: {
      "margin": "0 5px"
    }
  }, [_c('base-icon', {
    attrs: {
      "name": (_vm.icon ? _vm.icon : _vm.name)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    class: ['d-flex', 'flex-column', 'corner-rl', _vm.name + '-bg']
  }, [_c('div', {
    staticClass: "container"
  }, [_c('supplier-r-f-q-row', {
    attrs: {
      "tableName": _vm.name,
      "data": _vm.data,
      "title": "Awaiting Submission",
      "name": "awaitingSubmission",
      "rowClass": "pt-1"
    }
  }), _vm._v(" "), _c('supplier-r-f-q-row', {
    attrs: {
      "tableName": _vm.name,
      "data": _vm.data,
      "title": "Submitted",
      "name": "submitted"
    }
  }), _vm._v(" "), _c('supplier-r-f-q-row', {
    attrs: {
      "tableName": _vm.name,
      "data": _vm.data,
      "title": "New Responses",
      "name": "newResponses"
    }
  }), _vm._v(" "), _c('supplier-r-f-q-row', {
    attrs: {
      "tableName": _vm.name,
      "data": _vm.data,
      "title": "Awaiting Selection",
      "name": "awaitingSelection"
    }
  }), _vm._v(" "), _c('supplier-r-f-q-row', {
    attrs: {
      "tableName": _vm.name,
      "data": _vm.data,
      "title": "Past Due",
      "name": "pastDue"
    }
  }), _vm._v(" "), _c('supplier-r-f-q-row', {
    attrs: {
      "tableName": _vm.name,
      "data": _vm.data,
      "title": "Awarded",
      "name": "awarded",
      "rowClass": "mb-1"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-943ce40e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/SupplierRFQTable.vue
// module id = 755
// module chunks = 0